import authService from '../../services/AuthService';
import {call, put, select} from "redux-saga/effects";
import {
  challengeRequired, clearDecisionsStore, clearForgotPassword, clearQuickSightStore,
  clearTrelloStore, forgotPasswordSubmit,
  handleError,
  loginSuccessful, logoutSuccessful, refreshTokenSuccessful, logout as logoutAction,
  respondNewPasswordChallengeSuccessful
} from "../actions";
import {historyReplace} from '../utils';
import {HOME, NEW_PASSWORD} from "../../constants/routes";
import {authChallengeSelector, authTokenSelector} from "../selectors";

export function* login({
                         payload: {email, password}
                       }) {
  try {
    const result = yield authService.login(email, password);
    if ('challenge' in result) {
      if (result.challenge === 'NEW_PASSWORD_REQUIRED') {
        yield put(challengeRequired(result));
        yield put(historyReplace(NEW_PASSWORD));
      } else {
        yield put(() => {
          throw new Error('Unknown challenge');
        })
      }
    } else {
      yield put(loginSuccessful(result));
      yield put(historyReplace(HOME));
    }
  } catch (err) {
    yield put(handleError(err));
  }
}

export function* respondNewPasswordChallenge({
                                               payload: {newPassword}
                                             }) {
  try {
    const challenge = yield select(authChallengeSelector);
    const result = yield authService.respondNewPasswordChallenge(challenge.username, newPassword, challenge.session);
    yield put(respondNewPasswordChallengeSuccessful(result));
    yield put(historyReplace(HOME));
  } catch (err) {
    yield put(handleError(err));
  }
}

export function* logout() {
  try {
    yield authService.logout();
    yield put(logoutSuccessful());
    yield put(clearTrelloStore());
    yield put(clearQuickSightStore());
    yield put(clearDecisionsStore());
  } catch (err) {
    yield put(handleError(err));
  }
}

export function* refreshToken() {
  const token = yield select(authTokenSelector);
  if (!token) return;
  if (!token.refresh_token) {
    yield put(logoutAction());
    return;
  }
  try {
    const result = yield authService.refreshToken(token.refresh_token);
    yield put(refreshTokenSuccessful(result));
  } catch (err) {
    yield call(logout);
    yield put(historyReplace(HOME));
    yield put(handleError(err));
  }
}

export function* forgotPassword({
                                  payload: {username}
                                }) {
  try {
    yield authService.forgotPassword(username);
    yield put(forgotPasswordSubmit(username));
  } catch (err) {
    yield put(handleError(err));
  }
}

export function* clearForgotPasswordForm() {
  yield put(clearForgotPassword());
  yield put(historyReplace(HOME));
}

export function* confirmForgotPassword({
                                         payload: {username, code, newPassword}
                                       }) {
  try {
    yield authService.confirmForgotPassword(username, code, newPassword);
    yield put(clearForgotPassword());
    yield put(historyReplace(HOME));
  } catch (err) {
    yield put(handleError(err));
  }
}

